import { useEffect } from "react";

export const useAppendLandingId = (landingId, deps = []) => {
  useEffect(() => {
    if (!landingId) return;

    const timer = setTimeout(() => {
      const links = document.querySelectorAll("a[href]");
      links.forEach((link) => {
        if (link.href.startsWith("mailto:")) return;
        try {
          const url = new URL(link.href, window.location.origin);
          if (!url.searchParams.has("landing_id")) {
            url.searchParams.set("landing_id", landingId);
            link.href = url.toString();
          }
        } catch {}
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [landingId, ...deps]);
};
